import styled from 'styled-components';

export const StyledFieldErrorMessage = styled.div`
	margin-top: 5px;
	color: ${({ theme }) => theme.fontColors.error};
	font-size: 13px;
	font-weight: 500;
`;
